import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/database.types';
import { isAsyncJobsEnabled } from './featureFlags';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

/** P5: CreationPanel uses hydrate+Realtime when true (must match Edge USE_ASYNC_JOBS). */
export const asyncJobsEnabled = isAsyncJobsEnabled();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL or ANON KEY is missing.');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
